import {createSelector} from 'reselect';
import {getListingPage} from './store';

const getIsTypeaheadInputFocused = createSelector(
    [getListingPage],
    (listingPage) => {
        return listingPage.isTypeaheadInputFocused;
    }
);

const getShowDatePickerModalDesktop = createSelector(
    [getListingPage],
    (listingPage) => {
        return listingPage.showDatePickerModalDesktop;
    }
);

export {getIsTypeaheadInputFocused, getShowDatePickerModalDesktop};
